import React, { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import { authBaseUrl } from '../../config/runtime';
import './BillingPanel.css';

const plans = [
  { key: 'starter', name: 'Starter', instances: 1, price: 'R$ 0 (beta)' },
  { key: 'pro', name: 'Pro', instances: 3, price: 'R$ 199/mês' },
  { key: 'enterprise', name: 'Enterprise', instances: 10, price: 'Sob consulta' }
];

const BillingPanel = () => {
  const token = localStorage.getItem('token');
  const [status, setStatus] = useState(null);
  const [error, setError] = useState('');
  const [loadingPlan, setLoadingPlan] = useState('');
  const stripeEnabled = Boolean(process.env.REACT_APP_STRIPE_ENABLED);

  const fetchStatus = useCallback(async () => {
    try {
      const res = await axios.get(`${authBaseUrl}/billing/status`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setStatus(res.data);
    } catch (err) {
      setError('Falha ao carregar status de cobrança.');
    }
  }, [token]);

  useEffect(() => {
    fetchStatus();
  }, [fetchStatus]);

  const startCheckout = async (plan) => {
    setLoadingPlan(plan);
    setError('');
    try {
      const res = await axios.post(`${authBaseUrl}/billing/checkout`, { plan }, {
        headers: { Authorization: `Bearer ${token}` }
      });
      if (res.data?.url) {
        window.location.href = res.data.url;
      }
    } catch (err) {
      setError('Falha ao iniciar checkout.');
    } finally {
      setLoadingPlan('');
    }
  };

  return (
    <div className="billing-panel">
      <div className="billing-header">
        <div>
          <h2>Assinatura</h2>
          <p>Gerencie seu plano e limites de instâncias.</p>
        </div>
      </div>

      {error && <p className="error-message">{error}</p>}

      <div className="billing-status">
        <span>Plano atual: <strong>{status?.plan || 'starter'}</strong></span>
        <span>Status: <strong>{status?.stripe_status || 'ativo'}</strong></span>
        <span>Instâncias: <strong>{status?.used || 0}/{status?.instance_limit || 0}</strong></span>
      </div>

      <div className="billing-grid">
        {plans.map((plan) => (
          <div key={plan.key} className={`billing-card ${status?.plan === plan.key ? 'active' : ''}`}>
            <h3>{plan.name}</h3>
            <p className="billing-price">{plan.price}</p>
            <ul>
              <li>{plan.instances} instâncias WhatsApp</li>
              <li>Suporte prioritário</li>
              <li>Relatórios</li>
            </ul>
            <button onClick={() => startCheckout(plan.key)} disabled={loadingPlan === plan.key || !stripeEnabled}>
              {!stripeEnabled ? 'Stripe não configurado' : (loadingPlan === plan.key ? 'Processando...' : 'Assinar')}
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default BillingPanel;
